import { GlButton } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'SidebarFormattedDate',
    components: {
        GlButton
    },
    inject: [
        'canUpdate'
    ],
    props: {
        formattedDate: {
            required: true,
            type: String
        },
        hasDate: {
            required: true,
            type: Boolean
        },
        resetText: {
            required: true,
            type: String
        },
        isLoading: {
            required: true,
            type: Boolean
        },
        canDelete: {
            required: false,
            type: Boolean,
            default: true
        }
    },
    emits: [
        'reset-date'
    ]
};
